import React, { useState } from "react";

import { Paper, Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";

import { WidgetFilter } from "../../../../models/widget.filter";
import DashboardService from "../../../../services/dashboard.service";
import { useAppState } from "../../../../context/StateContext";
import { QuoteStatuses } from "../../../../types";
import StatusBarChart from "./components/StatusBarChart";
import { useStyles } from "./styles";

interface Props {
  filterInfo: WidgetFilter;
}

const QuotesStatuses = (props: Props) => {
  const { filterInfo } = props;

  const classes = useStyles();

  const { currentUser } = useAppState();

  const [quoteStatuses, setQuoteStatuses] = useState<QuoteStatuses>();

  useQuery(
    ["dashboard.quote.statuses.count", filterInfo],
    () =>
      DashboardService.getQuoteStatusesCount({
        dateFrom: filterInfo?.dateFrom,
        dateTo: filterInfo?.dateTo,
        companyId: currentUser?.companyId,
      }),
    {
      onSuccess: (response) => {
        if (response && response?.data) setQuoteStatuses(response?.data);
      },
      enabled: !!currentUser?.companyId,
    }
  );

  return (
    <Grid data-cy="quoteStatus" item xs={12}>
      <Paper className={classes.paper} elevation={0}>
        <StatusBarChart quoteStatuses={quoteStatuses} />
      </Paper>
    </Grid>
  );
};

export default QuotesStatuses;
